export default __webpack_public_path__ + "static/media/Mysore01.f971752c.jpg";